import React from "react";
import classNames from "classnames";
import { Link } from "react-router";
import LogoGraphic from "./CapRx-JUDILogoGraphic.svg";
import LogoText from "./CapRx-JUDILogoText.svg";
import MenuBarItem from "./MenuBarItem";
interface MenuBarRouteProps {
  label?: string;
  path: string;
  iconClassName?: string;
  exact?: boolean;
}
interface Props {
  menuBarRoutes: Array<MenuBarRouteProps>;
  collapsed: boolean;
}

const MenuBar: React.FC<Props> = ({ menuBarRoutes, collapsed }: Props): JSX.Element => {
  const menuBarClass = classNames("caprx-menu-bar", {
    "caprx-menu-bar-collapsed": collapsed,
  });

  const menuBarItems = menuBarRoutes.map((route) => {
    return (
      <MenuBarItem
        key={route.label}
        exact={route.exact}
        label={route.label}
        path={route.path}
        iconClassName={route.iconClassName}
      />
    );
  });

  return (
    <nav data-testid="menubar" className={menuBarClass}>
      <ul>
        <li className="caprx-menu-logo">
          <Link to="/" data-cy="home_button">
            <img src={LogoGraphic} alt="logo icon" />
            <img src={LogoText} alt="logo text icon" />
          </Link>
        </li>
        {menuBarItems}
      </ul>
    </nav>
  );
};

export default MenuBar;
